// OrderHistoryPage translations
export const orderHistoryTranslations = {
    en: {
        // Page title and headers
        myOrders: "My Orders",
        orderHistory: "Order History",

        // Loading and error states
        loadingOrders: "Loading your orders...",
        error: "Error",
        tryAgain: "Try Again",
        noStoreSelected: "No Store Selected",
        pleaseSelectStore: "Please select a store to view your orders.",
        goToHome: "Go to Home",

        // No orders state
        noOrdersFound: "No Orders Found",
        noOrdersPlaced: "You haven't placed any orders yet in this store.",
        startShopping: "Start Shopping",

        // Order card labels
        order: "Order",
        placedOn: "Placed on",
        total: "Total",
        items: "Items",
        payment: "Payment",
        date: "Date",

        // Order statuses
        processing: "Processing",
        pending: "Pending",
        confirmed: "Confirmed",
        shipped: "Shipped",
        delivered: "Delivered",
        completed: "Completed",
        cancelled: "Cancelled",
        refunded: "Refunded",

        // Payment methods
        cashOnDelivery: "Cash on Delivery",
        creditCard: "Credit Card",
        paypal: "PayPal",
        applePay: "Apple Pay",

        // Actions
        trackOrder: "Track Order",
        viewInvoice: "View Invoice",

        // General
        notAvailable: "N/A",
        guest: "Guest",
        noItemsToDisplay: "No items to display",

        // Error messages
        failedToLoad: "Failed to load your orders. Please try again later."
    },
    ar: {
        // Page title and headers
        myOrders: "طلباتي",
        orderHistory: "سجل الطلبات",

        // Loading and error states
        loadingOrders: "جاري تحميل طلباتك...",
        error: "خطأ",
        tryAgain: "حاول مرة أخرى",
        noStoreSelected: "لم يتم اختيار متجر",
        pleaseSelectStore: "يرجى اختيار متجر لعرض طلباتك.",
        goToHome: "الذهاب للرئيسية",

        // No orders state
        noOrdersFound: "لم يتم العثور على طلبات",
        noOrdersPlaced: "لم تقم بتقديم أي طلبات في هذا المتجر بعد.",
        startShopping: "ابدأ التسوق",

        // Order card labels
        order: "الطلب",
        placedOn: "تاريخ الطلب",
        total: "المجموع",
        items: "العناصر",
        payment: "الدفع",
        date: "التاريخ",

        // Order statuses
        processing: "قيد المعالجة",
        pending: "في الانتظار",
        confirmed: "مؤكد",
        shipped: "تم الشحن",
        delivered: "تم التسليم",
        completed: "مكتمل",
        cancelled: "ملغي",
        refunded: "تم الاسترداد",

        // Payment methods
        cashOnDelivery: "الدفع عند الاستلام",
        creditCard: "بطاقة ائتمان",
        paypal: "باي بال",
        applePay: "آبل باي",

        // Actions
        trackOrder: "تتبع الطلب",
        viewInvoice: "عرض الفاتورة",

        // General
        notAvailable: "غير متوفر",
        guest: "ضيف",
        noItemsToDisplay: "لا توجد عناصر للعرض",

        // Error messages
        failedToLoad: "فشل في تحميل طلباتك. يرجى المحاولة مرة أخرى لاحقاً."
    }
};

// Helper function to get translated text
export const getTranslation = (language, key) => {
    return orderHistoryTranslations[language]?.[key] || orderHistoryTranslations.en[key] || key;
};

// Helper function to get status translation
export const getStatusTranslation = (language, status) => {
    if (!status) return getTranslation(language, 'processing');

    const statusKey = status.toLowerCase();
    const translationKey = statusKey.replace(/_/g, ''); // Remove underscores

    return getTranslation(language, translationKey) || status;
};

// Helper function to get payment method translation
export const getPaymentMethodTranslation = (language, method) => {
    if (!method) return getTranslation(language, 'notAvailable');

    switch (method) {
        case 'cash_on_delivery':
            return getTranslation(language, 'cashOnDelivery');
        case 'credit_card':
            return getTranslation(language, 'creditCard');
        case 'paypal':
            return getTranslation(language, 'paypal');
        case 'apple_pay':
            return getTranslation(language, 'applePay');
        default:
            // Format snake_case to Title Case for fallback
            return method
                .replace(/_/g, ' ')
                .replace(/\b\w/g, l => l.toUpperCase());
    }
};
